import { useState, useEffect } from 'react';

function formatSeconds(millSeconds: number): string {
	const mill = millSeconds / 1000;
	const days = Math.floor(mill / (24 * 60 * 60))
		.toString()
		.padStart(2, '0');
	const hours = Math.floor((mill % (24 * 60 * 60)) / (60 * 60))
		.toString()
		.padStart(2, '0');
	const minutes = Math.floor((mill % (60 * 60)) / 60)
		.toString()
		.padStart(2, '0');
	const seconds = Math.floor(mill % 60)
		.toString()
		.padStart(2, '0');

	return `${days} : ${hours} : ${minutes} : ${seconds}`;
}

export const useCountdown = (targetTime: number) => {
	const [countDown, setCountDown] = useState(targetTime - new Date().getTime());

	useEffect(() => {
		const interval = setInterval(() => {
			setCountDown(countDown - 1000);
		}, 1000);

		return () => clearInterval(interval);
	}, [countDown]);

	return formatSeconds(countDown);
};
